import style from './Spinner.module.scss';

interface SpinnerProps {
  size?: number;
  color?: 'white' | 'blue';
}
export function Spinner({ size, color = 'blue' }: SpinnerProps) {
  return (
    <div className={style.spinner}>
      <div className={style.roller} style={{ scale: size }}>
        {[...Array(8)].map((el, i) => (
          <div key={`${el}${i}`} className={style[color]} />
        ))}
      </div>
    </div>
  );
}
